<template>
  <location-picker-list
    v-if="showLocationPicker"
    :location-ids="routeIds"
    @dismiss="handleDismiss"
  />
  <resource-picker-list
    v-else-if="showResourcePicker"
    :resource-ids="routeIds"
    @dismiss="handleDismiss"
  />
  <location-picker-for-job-cluster
    v-else-if="showLocationPickerForJobClusters"
    :jobs-grouped-by-location="parsedJobClusterData"
    @dismiss="handleDismiss"
  />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router/composables'
import LocationPickerList from './LocationPickerList.vue'
import ResourcePickerList from './ResourcePickerList.vue'
import LocationPickerForJobCluster from './LocationPickerForJobCluster.vue'

const props = defineProps<{
  ids: string
  source: string
}>()

const router = useRouter()

const routeIds = computed(() => props.ids?.split(','))

const parsedJobClusterData = computed(() => {
  if (!showLocationPickerForJobClusters.value) return {}
  return JSON.parse(props.ids) || {}
})

const showLocationPicker = computed(() => props.source === 'locations' && routeIds.value.length > 1)

const showResourcePicker = computed(() => props.source === 'resources' && routeIds.value.length > 1)

const showLocationPickerForJobClusters = computed(
  () => props.source === 'jobs-cluster' && props.ids.length > 1,
)

onMounted(() => {
  if (
    !showLocationPicker.value &&
    !showResourcePicker.value &&
    !showLocationPickerForJobClusters.value
  ) {
    // if the panel is initialized in an invalid state, auto-dismiss the panel
    handleDismiss()
  }
})

function handleDismiss() {
  router.replace({ name: 'field-view-next', hash: router.currentRoute.hash })
}
</script>
